import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import EllipsisDropdown from '../../../../../elements-dropdown/EllipsisDropdown';
import { Text } from '@ps-design-system/components/Text';

// TODO - remove once the new v2 sync flow is fully migrated
const ConnectCalendarCTA = (props) => {
  const {
    openSyncFlowModal,
    sync,
    getEllipsesDropdownItems
  } = props;

  const syncStatus = _.get(sync, 'status');

  const errorButton = (
    <button role="toggle" className="btn no-gutter remove-click-styling">
      <img src="https://assets.peerspace.com/alert.svg?v=rb"/>
    </button>
  );

  return (
    <div className="panel panel-body">
      <Text typeface="body-2-m">
        {'CONNECTED' === syncStatus || 'SYNCING' === syncStatus ?
          <FormattedMessage
            id="hosting.calendar_main.external_calendar_modal_heading_synced"
            defaultMessage="Synced calendar"
          /> :
          <FormattedMessage
            id="hosting.calendar_main.external_calendar_heading"
            defaultMessage="Connect your calendar"
          />
        }
      </Text>
      {
        syncStatus && 'NOT_CONNECTED' !== syncStatus ?
          <div className="margin-md-top">
            <div className="flex middle space-between">
              <div className="calendar-sync-cal-name-container">
                <div className="calendar-sync-cal-name-text">
                  {_.get(sync, 'calendarData.calendar_name')}
                </div>
                <div>
                  {'SYNCING' === syncStatus &&
                    <button onClick={() => location.reload()} style={{ border: 0 }} className="btn-link no-gutter">
                      <FormattedMessage
                        id="hosting.calendar_main.sync_refresh"
                        defaultMessage="Refresh Browser"
                      />
                    </button>}
                </div>
              </div>
              {
                'SYNCING' === syncStatus ?
                  <img className="spinner-animate-counter-clockwise" src="https://assets.peerspace.com/syncing.svg?v=rb"/> :
                  <EllipsisDropdown
                    pullRight
                    className="flex-shrink"
                    buttonClassName="btn no-gutter remove-click-styling"
                    listItems={getEllipsesDropdownItems()}
                    button={syncStatus && 'SYNC_ERROR' === syncStatus ? (errorButton) : ('')}
                  />
              }
            </div>
          </div> : syncStatus && 'NOT_CONNECTED' === syncStatus ? (
            <div className="margin-md-top margin-xxl-bottom">
              <Text typeface="body-2">
                <FormattedMessage
                  id="hosting.calendar_main.sync_calendar_getting_started_text"
                  defaultMessage="Link your external calendar to show your availability in real time and increase your bookings."
                />
              </Text>
              <button onClick={openSyncFlowModal} style={{ marginTop: '16px' }} className="btn btn-secondary btn-block">
                <FormattedMessage
                  id="hosting.calendar_main.notification_tooltip_button_text"
                  defaultMessage="Get Started"
                />
              </button>
            </div>
          ) : null
      }
    </div>
  );
};

ConnectCalendarCTA.propTypes = {
  sync: PropTypes.object.isRequired,
  openSyncFlowModal: PropTypes.func.isRequired,
  getEllipsesDropdownItems: PropTypes.func
};

export default ConnectCalendarCTA;
